import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.MRD_SETTINGS.isLoading;
export const getData = TableDefinitions.MRD_SETTINGS.getDataFunction();

export const getEditDeviceSettingsLoading = (state) => state.mrdSettings.editDeviceSettingsLoading;
